import { Controller, type Control, type FieldPath, type FieldValues } from "react-hook-form"
import { DateTimePicker } from "@/shared/components/ui/DateTimePicker"

interface DateTimeFieldProps<TFieldValues extends FieldValues = FieldValues> {
  name: FieldPath<TFieldValues>
  control: Control<TFieldValues>
  showTime?: boolean
  minDate?: Date
  maxDate?: Date
  className?: string
}

/**
 * React Hook Form controlled wrapper for DateTimePicker.
 * Handles the controlled component pattern for form integration.
 */
export function DateTimeField<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  showTime = true,
  minDate,
  maxDate,
  className = "",
}: DateTimeFieldProps<TFieldValues>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <DateTimePicker
          value={field.value ?? new Date()}
          onChange={field.onChange}
          showTime={showTime}
          minDate={minDate}
          maxDate={maxDate}
          className={className}
        />
      )}
    />
  )
}
